export default __webpack_public_path__ + "static/media/notice_icon.a6b0ab04.svg";